/**
 * Configurações da aplicação React
 * Todas as variáveis de ambiente devem começar com REACT_APP_
 */

const config = {
  // API
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  
  // Supabase (para uso futuro: tracking, realtime, progressive profiling)
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL,
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY,
  
  // Vendas — Telegram (LinkTwin). Não cair no WhatsApp.
  TELEGRAM_VENDAS_URL: process.env.REACT_APP_TELEGRAM_VENDAS_URL || 'https://linktw.in/XXvhRB',
  WHATSAPP_NUMBER: process.env.REACT_APP_WHATSAPP_NUMBER || '',
  WHATSAPP_MESSAGE: process.env.REACT_APP_WHATSAPP_MESSAGE || 'Eu+quero+comprar',
  // Fechar pedido (testee) → bot manda vídeo PIX + endereço. Túnel local do Mini App.
  TG_CART_CLOSE_URL: process.env.REACT_APP_TG_CART_CLOSE_URL || 'https://api-web-stories.vercel.app/tg/pwa-cart/close',
  
  // Social Links
  INSTAGRAM_URL: process.env.REACT_APP_INSTAGRAM_URL || 'https://www.instagram.com/madamycloset/',
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL || 'https://pariscloset.vip/',
  
  // Payment
  PREMIUM_PAYMENT_URL: process.env.REACT_APP_PREMIUM_PAYMENT_URL || 'https://pay.otimuspay.com/v3/?id=TPwAkuHdvDDAOE7BLqoGNXqs',
  
  // App Info
  APP_NAME: process.env.REACT_APP_NAME || 'Web Stories',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',

  // Gate = lab desacoplado. Off em produção até ordem expressa.
  // Local (npm start) fica ligado. Build de produção só liga com REACT_APP_GATE=1.
  GATE_ENABLED:
    process.env.REACT_APP_GATE === '1' ||
    process.env.REACT_APP_GATE === 'true' ||
    (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_GATE !== '0'),

  // Lab locale/moeda. Uma vitrine com seletores. Off no bundle de produção.
  LAB_ENABLED:
    process.env.REACT_APP_LAB === '1' ||
    process.env.REACT_APP_LAB === 'true' ||
    (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_LAB !== '0'),
  // Casca pública (projeto Vercel storefront-*). Só catálogo + stories.
  STOREFRONT_ENABLED:
    process.env.REACT_APP_STOREFRONT === '1' ||
    process.env.REACT_APP_STOREFRONT === 'true',
  STORE_LOCALE: process.env.REACT_APP_STORE_LOCALE || 'pt',
  STORE_CURRENCY: process.env.REACT_APP_STORE_CURRENCY || 'USD',
  // API do lab. Porta 8000 neste Mac é outro processo. Local default 8001.
  // Na casca pública usa a mesma API de produção.
  LAB_API_URL:
    process.env.REACT_APP_LAB_API_URL ||
    (process.env.REACT_APP_STOREFRONT === '1' || process.env.REACT_APP_STOREFRONT === 'true'
      ? process.env.REACT_APP_API_URL || 'https://api-web-stories.vercel.app'
      : 'http://localhost:8001'),
};

export default config;

